(function () {
  if (window.__bowndNewsletterLoaded) return;
  window.__bowndNewsletterLoaded = true;

  var KLAVIYO_REVISION = '2024-10-15';

  // Focal: Warenkorb-Drawer und Zähler neu laden
  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // Rabattcode direkt im Warenkorb hinterlegen (sichtbar im Drawer),
  // Fallback: Rabatt-Cookie, das erst im Checkout greift
  function applyDiscount(code) {
    if (!code) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart ' + response.status);
        refreshCart();
      })
      .catch(function () {
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', {
          credentials: 'same-origin'
        })
          .then(refreshCart)
          .catch(function () {});
      });
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function setBusy(button, isBusy) {
    if (!button) return;
    if (isBusy) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    } else {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }

  function bindForm(form) {
    if (form.dataset.klaviyoBound === 'true') return;
    form.dataset.klaviyoBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var companyId = form.dataset.klaviyoCompanyId;
      var listId = form.dataset.klaviyoListId;
      var source = form.dataset.klaviyoSource || 'Website';
      var discountCode = form.dataset.discountCode || '';

      var fields = form.querySelector('[data-newsletter-fields]');
      var successBanner = form.querySelector('[data-newsletter-success]');
      var errorBanner = form.querySelector('[data-newsletter-error]');
      var emailInput = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');

      var email = (emailInput && emailInput.value ? emailInput.value : '').trim();
      if (!email || !companyId || !listId) {
        if (errorBanner) errorBanner.hidden = false;
        return;
      }

      if (errorBanner) errorBanner.hidden = true;
      setBusy(button, true);

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': KLAVIYO_REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId }
              }
            }
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo ' + response.status);

          if (fields) fields.hidden = true;
          if (successBanner) successBanner.hidden = false;

          if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
            window.klaviyo.identify({ email: email });
          }

          return applyDiscount(discountCode);
        })
        .catch(function () {
          if (errorBanner) errorBanner.hidden = false;
        })
        .finally(function () {
          setBusy(button, false);
        });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('form[data-klaviyo-newsletter]').forEach(bindForm);
  }

  // Kopieren-Button (gilt für alle Newsletter-Formulare)
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-code]');
    if (!button) return;

    event.preventDefault();
    var code = button.getAttribute('data-copy-code');
    var label = button.querySelector('[data-copy-label]') || button;
    var defaultText = button.getAttribute('data-label-default') || 'Kopieren';
    var copiedText = button.getAttribute('data-label-copied') || 'Kopiert ✔';

    copyToClipboard(code)
      .then(function () {
        label.textContent = copiedText;
        setTimeout(function () { label.textContent = defaultText; }, 2500);
      })
      .catch(function () {
        var codeEl = button.parentElement && button.parentElement.querySelector('.bownd-discount__code');
        if (codeEl && window.getSelection) {
          var range = document.createRange();
          range.selectNodeContents(codeEl);
          var selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme-Editor: neu geladene Sections erneut binden
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();